<!-- eslint-disable vue/no-v-html -->
<template>
  <transition name="fade" tag="section">
    <p
      v-if="showOptIn"
      class="caption"
      v-html="
        isMemberGenerated ? $t('action.gdprTermsMGP', locale) : $t('action.gdprTerms', locale)
      "
    />
    <p v-else class="caption">
      <span
        v-html="
          isMemberGenerated
            ? $t('action.nonGdprTermsMGP', locale)
            : $t('action.nonGdprTerms', locale)
        "
      />
    </p>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'SectionDisclaimer',
  computed: {
    ...mapState('actionForm', ['locale']),
    ...mapGetters('actionForm', ['showOptIn', 'isMemberGenerated'])
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
